import * as React from "react";
import { endOfDay, startOfDay } from "date-fns";

export const ActiveDate = React.createContext<{
    fromDate: null | Date;
    toDate: null | Date;
    selectedDate: null | Date;
    handleChange: (newValueFrom: Date, newValueTo: Date) => void;
}>({
    fromDate: null,
    toDate: null,
    selectedDate: null,
    handleChange: (_newValueFrom: Date, _newValueTo: Date) => {},
});

export const ActiveDateProvider = ({ children }) => {
    const [fromDate, setFromDate] = React.useState<Date | null>(null);
    const [toDate, setToDate] = React.useState<Date | null>(null);
    const [selectedDate, setSelectedDate] = React.useState<Date | null>(null);

    const handleChange = (newValueFrom: Date, newValueTo: Date) => {
        setSelectedDate(newValueFrom);
        setFromDate(startOfDay(newValueFrom));
        setToDate(endOfDay(newValueTo));
    };

    const value = React.useMemo(
        () => ({ selectedDate, handleChange, fromDate, toDate }),
        [selectedDate && JSON.stringify(selectedDate), handleChange, fromDate, toDate]
    );

    return <ActiveDate.Provider value={value}>{children}</ActiveDate.Provider>;
};

const useActiveDate = () => {
    const context = React.useContext(ActiveDate);
    if (context === undefined) {
        throw new Error(
            `useActiveIntegrationsTeams must be used within a ActiveIntegrationsProviderTeams`
        );
    }
    return context;
};

export { useActiveDate };
